import IconChevronDownLarge from '@picsart/icons/IconChevronDownLarge';
import {
  AccordionItem as ReachAccordionItem,
  AccordionButton as ReachAccordionButton,
  AccordionPanel as ReachAccordionPanel,
} from '@reach/accordion';
import classNames from 'classnames';

import useStyles from './styles';
import { IAccordionItem } from './types';

function AccordionItem({ className, toggleContent, children }: IAccordionItem) {
  const classes = useStyles();

  return (
    <ReachAccordionItem className={classNames(classes.item, className)}>
      <ReachAccordionButton className={classes.toggle}>
        <div style={{ flex: 1 }}>{toggleContent}</div>
        <IconChevronDownLarge className={classes.chevron} />
      </ReachAccordionButton>
      <ReachAccordionPanel className={classes.content}>{children}</ReachAccordionPanel>
    </ReachAccordionItem>
  );
}

export default AccordionItem;
